// extracted by mini-css-extract-plugin
export var core = "FiftyFifty-module--core--H6hrh";
export var customMargin = "FiftyFifty-module--custom-margin--UzuKp";
export var flexList = "FiftyFifty-module--flex-list--S+U5C";